
import { defineComponent, onMounted, reactive, ref, toRaw, UnwrapRef } from 'vue';
import { ChangePwdFormState, genInitFormState } from './interface';
import { RuleObject } from 'ant-design-vue/lib/form/interface';
import { changeNucPass, ModifyPwdQo } from '@/services/user';
import { get } from 'lodash';
import { message } from 'ant-design-vue';
import { getLoginPath } from '@/utils/uri';
import { removeToken } from '@/utils/token';
import ChangePwdCrossTab from './crossTab';

export default defineComponent({
  name: 'ChangePwdDialog',
  setup() {
    const visible = ref(false);
    const loading = ref(false);
    const formRef = ref();
    const formState: UnwrapRef<ChangePwdFormState> = reactive(genInitFormState());

    const handleValidatePwd = async(rule: RuleObject, value: string) => {
      if (value === '') {
        return Promise.reject('请输入新密码');
      } else {
        if (formState.confirmPasswprd !== '') {
          formRef.value.validateFields('confirmPasswprd');
        }
        return Promise.resolve();
      }
    };

    const handleValidateConfirmPwd = async(rule: RuleObject, value: string) => {
      if (value === '') {
        return Promise.reject('请再次输入新密码');
      } else if (value !== formState.password) {
        return Promise.reject('两次输入密码不一致');
      } else {
        return Promise.resolve();
      }
    };

    const rules = {
      oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'change' }],
      password: [{ required: true, validator: handleValidatePwd, trigger: 'change' }],
      confirmPasswprd: [{required: true, validator: handleValidateConfirmPwd, trigger: 'change'}]
    };

    const layout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 }
    };



    const handleOpen = () => {
      visible.value = true;
    };

    const handleClose = () => {
      visible.value = false;
      setTimeout(() => {
        formRef.value?.resetFields();
      }, 300);
    };

    const fmtReqParams = (params: ChangePwdFormState): ModifyPwdQo => ({
      oldPassword: params.oldPassword,
      newPassword: params.password,
      confirmPassword: params.confirmPasswprd,
    });

    const fetchChangePwd = async() => {
      try {
        loading.value = true;
        const response = await changeNucPass(fmtReqParams(toRaw(formState)));

        if (get(response, 'data.success')) {
          message.success('修改密码成功, 即将跳转至登录页', 5);
          handleClose();
          setTimeout(() => {
            removeToken();
            ChangePwdCrossTab.sendMessage();
            window.location.href = getLoginPath();
          }, 1000);
        } else {
          message.error(get(response, 'data.msg') || '修改密码失败');
        }
      } catch (e) {
        message.error('修改密码失败');
      } finally {
        loading.value = false;
      }
    };

    const handleSubmit = () => {
      formRef.value?.validate().then(() => {
        fetchChangePwd();
      }).catch((err: unknown) => {
        console.log(err);
      });
    };

    onMounted(() => {
      window.__openChangePwdDialog = handleOpen;
    });

    return {
      visible,
      loading,
      formRef,
      formState,
      rules,
      layout,
      handleSubmit,
      handleClose,
    };
  }
});
